import React from 'react';

import PropTypes from 'prop-types';

import FormTemplatesListView from './FormTemplatesListView';
import FormTemplatesTreeView from './FormTemplatesTreeView';
import { useFormsFolders } from '../hooks';

const FormTemplatesCustomDataView = ({ filters = {}, ...rest }) => {
  const { data: folders, isLoading: isLoadingFolders } = useFormsFolders();

  return filters.searchExpression ? (
    <FormTemplatesListView
      filters={filters}
      isLoadingFolders={isLoadingFolders}
      folders={folders}
      {...rest}
    />
  ) : (
    <FormTemplatesTreeView
      filters={filters}
      isLoadingFolders={isLoadingFolders}
      folders={folders}
      {...rest}
    />
  );
};

FormTemplatesCustomDataView.displayName = 'FormTemplatesCustomDataView';

FormTemplatesCustomDataView.propTypes = {
  /**
   * Whether is loading Forms from BE.
   */
  loading: PropTypes.bool,
  /**
   * IDs of selected Form entities.
   */
  selectedIds: PropTypes.arrayOf(PropTypes.string),
  /**
   * IDs of Form entities we want to mark as disabled.
   */
  disabledIds: PropTypes.arrayOf(PropTypes.string),
  /**
   * Whether the component is multi selectable.
   */
  multiple: PropTypes.bool,
  /**
   * List of entities.
   */
  entities: PropTypes.arrayOf(PropTypes.object),
  /**
   * Callback to set Selections.
   * Handler is of shape: (selectedNodes) => *
   */
  setSelection: PropTypes.func,
  /**
   * The currently applied filters.
   */
  filters: PropTypes.object,
  /**
   * callback to add entities to cache. Shape: ({ entities, domain, type }) => *.
   */
  addEntitiesToCache: PropTypes.func,
  /**
   * Additional props to pass to DataView.
   */
  dataViewProps: PropTypes.shape({
    inheritedTemplateIds: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default FormTemplatesCustomDataView;
